"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HamburgerContainer = exports.HamburgerIcon = exports.Logo = exports.Icon = exports.Mobile = exports.MOBILE_HEADER_HEIGHT = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MOBILE_HEADER_HEIGHT = '84px';
exports.MOBILE_HEADER_HEIGHT = MOBILE_HEADER_HEIGHT;
var Mobile = (0, _styledComponents["default"])(_slice.Box).attrs({
  bg: 'white',
  p: 2
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  display: block;\n  height: ", ";\n  position: ", ";\n  width: calc(100% - 50px);\n  top: 0;\n  left: ", ";\n  margin-left: 52px;\n  z-index: 2000;\n\n  ", " {\n    display: none;\n    position: relative;\n  }\n"], ["\n  display: block;\n  height: ", ";\n  position: ", ";\n  width: calc(100% - 50px);\n  top: 0;\n  left: ", ";\n  margin-left: 52px;\n  z-index: 2000;\n\n  ", " {\n    display: none;\n    position: relative;\n  }\n"])), MOBILE_HEADER_HEIGHT, function (props) {
  return props.isSticky ? 'fixed' : 'static';
}, function (props) {
  return props.isSticky ? '0' : '52px';
}, _slice.mediaQueries[0]);
exports.Mobile = Mobile;
var Icon = (0, _styledComponents["default"])(_slice.Box)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  width: 44px;\n"], ["\n  width: 44px;\n"])));
exports.Icon = Icon;
var Logo = (0, _styledComponents["default"])(_slice.Box)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.Logo = Logo;
var HamburgerIcon = (0, _styledComponents["default"])(_slice.Box)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  width: 44px;\n  position: ", ";\n  top: 16px;\n  left: 8px;\n"], ["\n  width: 44px;\n  position: ", ";\n  top: 16px;\n  left: 8px;\n"])), function (props) {
  return props.isSticky ? 'fixed' : 'absolute';
});
exports.HamburgerIcon = HamburgerIcon;
var HamburgerContainer = (0, _styledComponents["default"])(_slice.Box)(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)(["\n  width: 52px;\n  height: ", ";\n  background-color: ", ";\n  position: ", ";\n  top: 0;\n  left: 0;\n  display: ", ";\n"], ["\n  width: 52px;\n  height: ", ";\n  background-color: ", ";\n  position: ", ";\n  top: 0;\n  left: 0;\n  display: ", ";\n"])), MOBILE_HEADER_HEIGHT, function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
}, function (props) {
  return props.isSticky ? 'fixed' : 'absolute';
}, function (props) {
  return props.isOpen ? 'none' : 'initial';
});
exports.HamburgerContainer = HamburgerContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;